export default {
    updateUserId(state, payload) {
        if (!payload) return;
        state.User = payload;
        state.UserId = payload.userId;
        localStorage.setItem('userId', state.UserId);
    },

    updateUserLogin(state, payload) {
        if (!payload) return;
        state.User = { UserName: payload.UserName };
        localStorage.setItem('Jwt', payload.access_token);
    },
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
}